import {
    GET_EQUITY_DETAILS,
    GET_EQUITY_DETAILS_SUCCESS,
    GET_EQUITY_DETAILS_FAILURE,
    EQUITY_USAGE_ATTACHMENT_UPLOAD,
    EQUITY_USAGE_ATTACHMENT_UPLOAD_FAILURE,
    EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
    EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
    EQUITY_DELETE_ATTACHMENT_REQUEST,
    EQUITY_DELETE_ATTACHMENT_REQUEST_SUCCESS,
    EQUITY_DELETE_ATTACHMENT_REQUEST_FAILURE,
    EQUITY_RESET_PO_ATTACHMENT,
    EQUITY_GET_IMAGE_PO_PREVIEW,
    EQUITY_GET_IMAGE_PO_PREVIEW_SUCCESS,
    EQUITY_GET_IMAGE_PO_PREVIEW_FAILURE,
    STORE_EQUITY_REFERENCE,
    RESET_EQUITY_REFERENCE,
} from '../actions/actionTypes';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    equityDetails: {
        myCaseRef: '',
        myCaseRefValue: '',
    },
    myCaseRefId: null,
    myCaseResourceType: null,
    isdeletionDone: false,
    isUsageAttachmentUploaded: false,
    poTissueImageDetails: '',
    poNonTissueImageDetails: '',
    poImagePreviewLoader: false,
    poImagePreviewDetails: null,
    poImageUploadLoader: false,
    poImageDeleteLoader: false,
};

const equityDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EQUITY_DETAILS:
            return {
                ...state,
                ...initialState,
                // myCaseRef: action.myCaseRef,
            };
        case GET_EQUITY_DETAILS_SUCCESS:
            return {
                ...state,
                equityDetails: {
                    myCaseRef: action.myCaseRef,
                },
            };
        case GET_EQUITY_DETAILS_FAILURE:
            return {
                ...state,
                equityDetails: {
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
            };
        case EQUITY_USAGE_ATTACHMENT_UPLOAD:
            return {
                ...state,
                poImageUploadLoader: true,
            };
        case EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE:
            return {
                ...state,
                poNonTissueImageDetails: action.payload,
                poImageUploadLoader: false,
            };
        case EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE:
            return {
                ...state,
                poTissueImageDetails: action.payload,
                poImageUploadLoader: false,
            };
        case EQUITY_USAGE_ATTACHMENT_UPLOAD_FAILURE:
            return {
                ...state,
                isUsageAttachmentUploaded: false,
                poImageUploadLoader: false,
            };
        case EQUITY_DELETE_ATTACHMENT_REQUEST:
            return {
                ...state,
                poImageDeleteLoader: true,
            };
        case EQUITY_DELETE_ATTACHMENT_REQUEST_SUCCESS:
            return {
                ...state,
                poTissueImageDetails: action.payload.isTissue
                    ? action.payload.imagesToBeUpdated
                    : state.poTissueImageDetails,
                poNonTissueImageDetails: !action.payload.isTissue
                    ? action.payload.imagesToBeUpdated
                    : state.poNonTissueImageDetails,
                poImageDeleteLoader: false,
            };
        case EQUITY_RESET_PO_ATTACHMENT:
            return {
                ...state,
                poTissueImageDetails: '',
                poNonTissueImageDetails: '',
            };
        case EQUITY_DELETE_ATTACHMENT_REQUEST_FAILURE:
            return {
                ...state,
                isdeletionDone: false,
                poImageDeleteLoader: false,
            };
        case EQUITY_GET_IMAGE_PO_PREVIEW:
            return {
                ...state,
                poImagePreviewLoader: true,
            };
        case EQUITY_GET_IMAGE_PO_PREVIEW_SUCCESS:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: action.payload,
            };
        case EQUITY_GET_IMAGE_PO_PREVIEW_FAILURE:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: null,
            };
        case STORE_EQUITY_REFERENCE:
            return {
                ...state,
                equityDetails: {
                    ...state.equityDetails,
                    myCaseRefValue: action.payload,
                },
            };
        case RESET_EQUITY_REFERENCE:
            return {
                ...state,
                ...initialState,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'equityDetailsKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    equityDetailsReducer
);
